import { Link } from 'react-router-dom';
import LogoutButton from './LogoutButton';

export default function Header({
  logout,
  user,
  adminPortal = false,
}) {
  return (
    <div className='fixed left-0 top-0 w-full h-12 bg-white z-10 flex items-center justify-center sm:justify-between px-6 shadow-md'>
      <Link
        to={adminPortal ? '/admin/competitions' : '/'}
        className='text-xl font-semibold text-black hover:text-yellow-500 transition-colors'
      >
        {adminPortal ? 'Admin Portal' : 'Competition Registration'}
      </Link>

      {user && <LogoutButton onLogout={logout} />}
    </div>
  );
}
